/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Insights_DescriptionInputs */

const en_why_listening_insights_description = /** @type {(inputs: Why_Listening_Insights_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every document you upload gets an AI overview and key points, so you know what it says before you press play.`)
};

const es_why_listening_insights_description = /** @type {(inputs: Why_Listening_Insights_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada documento que subes recibe un resumen y puntos clave generados con IA, para que sepas qué dice antes de darle a reproducir.`)
};

/**
* | output |
* | --- |
* | "Every document you upload gets an AI overview and key points, so you know what it says before you press play." |
*
* @param {Why_Listening_Insights_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_insights_description = /** @type {((inputs?: Why_Listening_Insights_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Insights_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_insights_description(inputs)
	return en_why_listening_insights_description(inputs)
});